<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.reservation') }}
              </div>
              <v-spacer />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }" :style="{ marginBottom: marginMenuBottom + 'px' }">
      <v-container class="pt-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
            <div class="mt-2">
              <div class="pa-4 ol-elevation-2 br-8">
                <div class="list-component">
                  <div class="list-avatar mr-4 align-self-center">
                    <img :src="$store.state.selected_outlet.logo" :alt="$store.state.selected_outlet.name" class="list-image">
                  </div>
                  <div class="list-content">
                    <div class="list-content-title font-18 font-weight-700 mb-2">
                      {{ $store.state.selected_outlet.name }}
                    </div>
                    <div class="mb-1 list-content-title">
                      <div class="d-inline-flex align-center tag-reservation">
                        <v-icon size="18" color="#272727" class="mr-1">
                          mdi-clock-outline
                        </v-icon>
                        {{ working_hours }}
                      </div>
                    </div>
                    <div v-if="!$isEmpty(select_store) && Number(select_store.reservation.minimum_order_amount) > 0">
                      <div class="d-inline-flex align-center tag-reservation">
                        <v-icon size="20" color="#272727" class="mr-1">
                          mdi-cash
                        </v-icon>
                        Min. order <span v-mask-money="select_store.reservation.minimum_order_amount" class="ml-1" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-6">
              <div class="mb-4">
                <v-dialog ref="dialog_date" v-model="dialog.date" :return-value.sync="form.reserve_date" persistent width="290px" content-class="antr-dialog-date-picker">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="font-12 ol-black mb-1">
                      {{ $t('v2.reservation_date') }}
                    </div>
                    <v-text-field v-model="dateFormatted" :placeholder="$t('v2.choose_date')" outlined dense height="40" readonly hide-details v-bind="attrs" class="input--button" v-on="on">
                      <template v-slot:append>
                        <div class="d-flex">
                          <img src="@/assets/images/v2/img/icon_calender.png" alt="Calender" class="image-20">
                        </div>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="form.reserve_date" scrollable :min="minDate">
                    <v-spacer />
                    <v-btn text color="primary" class="text-none" @click="dialog.date = false">
                      {{ $t('v2.cancel3') }}
                    </v-btn>
                    <v-btn text color="primary" class="text-none" @click="selectDate()">
                      Ok
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </div>
              <div>
                <div class="font-12 ol-black mb-1">
                  {{ $t('v2.time') }}
                </div>
                <ValidationProvider v-slot="{ errors }" name="reserve_time" :rules="{ required: true }">
                  <v-select v-model="form.reserve_time" :placeholder="!time_disabled ? $t('v2.choose_reservation_time') : $t('v2.reservation_hours_are_not_available')" :items="list_hour" outlined dense height="40" :error-messages="errors" :disabled="time_disabled || disabled" class="input--button" @change="selectTime()" />
                </ValidationProvider>
              </div>
              <div v-if="time_disabled" class="flex-image pa-4 br-10" style="background-color: #FFF2E3;">
                <div class="flex-image-avatar mr-2">
                  <v-icon color="#FF931E" size="20">
                    mdi-alert-outline
                  </v-icon>
                </div>
                <div class="flex-image-content">
                  <div class="flex-image-content-text font-14">
                    {{ $t('v2.reservation_time_is_not_available_on_the_selected_date') }}
                  </div>
                </div>
              </div>
              <div v-else-if="max_visitors === null || (max_guest && max_guest >= 1)">
                <div class="font-12 ol-black mb-1">
                  {{ $t('v2.number_of_tables') }}
                </div>
                <ValidationProvider v-slot="{ errors }" name="total_guest" :rules="guestRules">
                  <!-- <v-select v-model="form.total_guest" :placeholder="$t('v2.select_the_number_of_tables')" :items="list_visitor" outlined dense height="40" :error-messages="errors" :disabled="disabled" class="input--button" /> -->
                  <v-text-field v-model="form.total_guest" :placeholder="$t('v2.select_the_number_of_tables')" outlined dense height="40" readonly hide-details :disabled="disabled" class="input--button">
                    <template v-slot:append>
                      <v-btn icon width="24" height="24" class="mr-2" @click="minus()">
                        <v-icon>
                          mdi-minus
                        </v-icon>
                      </v-btn>
                      <v-btn icon width="24" height="24" @click="plus()">
                        <v-icon>
                          mdi-plus
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                  <div v-if="max_visitors" class="v-text-field__details mt-1">
                    <div :class="['v-messages', { 'ol-grey-content': valid || !validated, 'error--text': errors.length }]">
                      <div class="v-messages__message message-transition-enter-to">
                        {{ $t('v2.validate_max_guest', { max_table: max_guest }) }}
                      </div>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </ValidationObserver>
    <div ref="refMenuBottom" class="fixed-bottom">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
            <v-btn block color="v2_primary" height="40" :disabled="disableNext || time_disabled || (max_guest !== null && max_guest !== undefined && max_guest < 1)" class="br-5 text-none white--text font-16 font-weight-bold btn-v2-shadow" @click="saveDetailReservation()">
              {{ $t('v2.next') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import { getLocale } from '@/utils/locale'
import {
  checkReserve as checkReserveTime,
  reserveTimes as getReserveTime
} from '@/api/setting'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    const today = new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10)
    return {
      dialog: {
        date: false
      },
      min_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      select_store: {},
      data_reserve: {},
      form: {
        reserve_date: today,
        reserve_time: '',
        total_guest: 1
      },
      list_visitor: [],
      max_guest: null,
      max_visitors: null,
      time_disabled: false,
      disabled: true,
      margin_menu_bottom: 0,
      detail_reservation: {}
    }
  },
  computed: {
    guestRules() {
      if (this.max_visitors === null) {
        return { required: true }
      }
      return { required: true, max_guest: this.max_guest }
    },
    disableNext() {
      if (this.form.reserve_date !== '' && this.form.reserve_time !== '' && this.form.total_guest !== '') {
        return false
      }
      return true
    },
    marginMenuBottom() {
      return this.margin_menu_bottom
    },
    working_hours() {
      var select_store = this.$store.state.selected_store
      if (this.$store.state.selected_outlet) {
        select_store = this.$store.state.selected_outlet
      }
      const today = new Date()
      const curTd = today.getDay()
      let working_time = {}
      let working_hours = 'Tutup'
      if (curTd === 0) {
        working_time = select_store.working_hours[6]
      } else {
        working_time = select_store.working_hours[curTd - 1]
      }
      if (working_time.times.length > 0) {
        working_hours = working_time.times[0].fstart_time + ' - ' + working_time.times[working_time.times.length - 1].fend_time
      }
      return working_hours
    },
    dateFormatted() {
      return this.formatDate(this.form.reserve_date)
    },
    list_hour() {
      const list = []
      if (!this.$isEmpty(this.data_reserve) && this.data_reserve.reservation_time_in_date.length > 0) {
        this.data_reserve.reservation_time_in_date.map((item) => {
          item.split_times.map((time) => {
            if (time.time_has_passed === 0) {
              if (this.data_reserve.max_visitors === null || this.data_reserve.max_visitors > time.used_slot) {
                list.push(time.fstart_time)
              }
            }
          })
        })
      }
      return list
    },
    minDate() {
      if (!this.$isEmpty(this.data_reserve)) {
        if (Number(this.data_reserve.type_time_reservation) === 1) {
          if (Number(this.data_reserve.maximum_time_for_reservation_type) === 0) {
            var date = new Date()
            date.setDate(date.getDate() + this.data_reserve.maximum_time_for_reservation)
            const max_date = date.toISOString().substr(0, 10)
            return max_date
          } else {
            return this.min_date
          }
        } else {
          return this.min_date
        }
      } else {
        return this.min_date
      }
    }
  },
  mounted() {
    const DETAIL_RESERVATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_detail_reservation')
    if (DETAIL_RESERVATION) {
      const detail_reservation = JSON.parse(DETAIL_RESERVATION)
      const reserve_now = new Date().getTime()
      const reserve_date = new Date(detail_reservation.reserve_date + ' ' + detail_reservation.reserve_time).getTime()
      if (reserve_date) {
        if (reserve_now >= reserve_date) {
          this.detail_reservation = {}
          this.$store.dispatch('delDetailReservationV2')
        } else {
          this.detail_reservation = detail_reservation
          this.form.reserve_date = this.detail_reservation.reserve_date
          this.getTimes()
        }
      }
    }
    this.margin_menu_bottom = this.$refs.refMenuBottom.clientHeight
    this.select_store = this.$store.state.selected_store
    if (this.$store.state.selected_outlet) {
      this.select_store = this.$store.state.selected_outlet
    }
    if (this.form.reserve_date) {
      this.selectDate()
    }
  },
  methods: {
    minus() {
      if (this.form.total_guest > 1) {
        this.form.total_guest--
      }
    },
    plus() {
      if (this.max_visitors === null || this.form.total_guest < this.max_guest) {
        this.form.total_guest++
      }
    },
    goBack() {
      const query = this.$route.query.redirect
      if (query) {
        this.$router.push({ name: query }).catch(() => {})
      } else {
        this.$router.push({ name: '_splash' }).catch(() => {})
      }
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      var selectedlocale = getLocale()
      if (selectedlocale === undefined || selectedlocale == null) {
        selectedlocale = process.env.VUE_APP_I18N_LOCALE
      }
      let month_name = ''
      if (selectedlocale === 'id') {
        if (month === '01') {
          month_name = 'Januari'
        } else if (month === '02') {
          month_name = 'Februari'
        } else if (month === '03') {
          month_name = 'Maret'
        } else if (month === '04') {
          month_name = 'April'
        } else if (month === '05') {
          month_name = 'Mei'
        } else if (month === '06') {
          month_name = 'Juni'
        } else if (month === '07') {
          month_name = 'Juli'
        } else if (month === '08') {
          month_name = 'Agustus'
        } else if (month === '09') {
          month_name = 'September'
        } else if (month === '10') {
          month_name = 'Oktober'
        } else if (month === '11') {
          month_name = 'November'
        } else {
          month_name = 'Desember'
        }
      } else {
        if (month === '01') {
          month_name = 'January'
        } else if (month === '02') {
          month_name = 'February'
        } else if (month === '03') {
          month_name = 'March'
        } else if (month === '04') {
          month_name = 'April'
        } else if (month === '05') {
          month_name = 'May'
        } else if (month === '06') {
          month_name = 'June'
        } else if (month === '07') {
          month_name = 'July'
        } else if (month === '08') {
          month_name = 'August'
        } else if (month === '09') {
          month_name = 'September'
        } else if (month === '10') {
          month_name = 'October'
        } else if (month === '11') {
          month_name = 'November'
        } else {
          month_name = 'December'
        }
      }
      return `${day} ${month_name} ${year}`
    },
    selectDate() {
      this.max_guest = null
      if (this.form.reserve_date) {
        this.$refs.dialog_date.save(this.form.reserve_date)
        this.disabled = false
        this.form.reserve_time = ''
        this.form.total_guest = 1
        this.$refs.observer.reset()
        this.getTimes()
      }
    },
    async getTimes() {
      this.time_disabled = false
      this.list_visitor = []
      try {
        const params = {
          reserve_date: this.form.reserve_date
        }
        const { data } = await getReserveTime(params)
        this.max_visitors = data.data.max_visitors
        this.$store.state.loading_axios = false
        this.data_reserve = data.data
        if (!this.$isEmpty(this.detail_reservation)) {
          this.time_disabled = false
          this.disabled = false
          this.form.reserve_time = this.detail_reservation.reserve_time
          this.selectTime()
        } else {
          if (this.data_reserve.reservation_time_in_date.length === 0) {
            this.time_disabled = true
          } else {
            this.time_disabled = this.data_reserve.reservation_time_in_date.every(item =>
              item.split_times.every(time =>
                time.time_has_passed === 1 || this.data_reserve.max_visitors === time.used_slot
              )
            )
          }
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async selectTime() {
      try {
        const form = {
          // time: this.reserve_hour + ':' + this.reserve_minute
          time: this.form.reserve_time,
          reserve_date: this.form.reserve_date
        }
        const { data } = await checkReserveTime(form)
        this.$store.state.loading_axios = false
        this.list_visitor = []
        if (Number(data.data.availability_slot) > 0) {
          for (let i = 1; i < (Number(data.data.availability_slot) + 1); i++) {
            this.list_visitor.push(i)
          }
        }
        this.max_guest = data.data.availability_slot
        if (!this.$isEmpty(this.detail_reservation)) {
          this.form.total_guest = this.detail_reservation.total_guest
          this.detail_reservation = {}
        }
        // this.availability_slot = data.data.availability_slot
        // this.dialog.reserve_time = false
        // if (this.reserve_hour && this.reserve_minute) {
        //   this.sendToForm.reserve_time = this.reserve_hour + ':' + this.reserve_minute
        // }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    saveDetailReservation() {
      this.$store.dispatch('saveDetailReservationV2', this.form)
      const query = this.$route.query.redirect
      if (query) {
        this.$router.push({ name: query }).catch(() => {})
      } else {
        this.$router.push({ name: '_menu' }).catch(() => {})
      }
    }
  }
}
</script>
